import ToggleableLink from "components/Common/ToggleableLink";
import { addDays, addMonths, addQuarters, addWeeks, addYears, differenceInDays, differenceInMonths, differenceInQuarters, differenceInWeeks, differenceInYears } from "date-fns";
import _ from "lodash";
import { ADMIN_ANALYTICS_TIMEFRAME_GROUP_BY_KEYS, ANALYTICS_TIMEFRAME_GROUP_BY_KEYS, UTC_TIMEZONE } from "./sf_constants";
import { booleanToString, findbyGroupByKeysAdminAnalytics, forColumnHeaderWrapper } from "./sf_utils";
import { getZonedStartOfDay, getZonedStartOfMonth, getZonedStartOfQuarter, getZonedStartOfWeek, getZonedStartOfYear } from "./time_utils";
import { formatInTimeZone } from "date-fns-tz";

export const minHeightFormatter = (content, feature_flag = true, _displayBoolean = false, isExport=false) => {
    const displayContent = booleanToString(content);
    if (isExport) {
        return displayContent;
    }
    return (
        <div style={feature_flag ? { minHeight: '24px', marginTop: '4px' } : {}}>
            <span>{displayContent}</span>
        </div>
    );
}
export const campaignNameFormatterForAnalytics = (cell, row, feature_flag) => (
    minHeightFormatter(
        <ToggleableLink to={`/campaigns/${row.campaign_id}/summary`} disabled={row.campaign_discarded_at}>
            <div className={row.campaign_discarded_at ? '' : 'text-sfblue'}>{(`${cell}${row.campaign_discarded_at ? ' (deleted)' : ''}`)}</div>
        </ToggleableLink>, feature_flag)
)
export const campaignNameFormatter = (cell, row, _) => (
    <ToggleableLink to={`/campaigns/${row.campaign_id}/summary`} disabled={row.campaign_discarded_at}>
        <div className={row.campaign_discarded_at ? '' : 'text-sfblue'}>{`${cell}${row.campaign_discarded_at ? ' (deleted)' : ''}`}</div>
    </ToggleableLink>
)

export const campaignNameCsvFormatter = (cell, row, _) => (`${cell || ''}${row.campaign_discarded_at ? ' (deleted)' : ''}`)

export const nameWithDeletedFormatter = (cell, row, _, discarded_at_field_name) => (`${cell || ''}${row[discarded_at_field_name] ? ' (deleted)' : ''}`);

export const dateFormatter = (cell) => (cell != null ? formatInTimeZone(cell, UTC_TIMEZONE, "yyyy-MM-dd HH:mm:ss") : '');

export const getKeywordSourceGroupByColumn = (formatter, csvFormatter = formatter, footerFormatter = () => '') => ([{
    dataField: 'ks',
    text: 'Keyword Source',
    headerFormatter: forColumnHeaderWrapper,
    formatter,
    csvFormatter,
    sort: true,
    sticky: true,
    footer: 'Keyword Source',
    footerFormatter
}]);

//Create a function that takes campaign analysis object and returns 

export const onFilterByDisqualif = (filterVal, data) => {
    if (filterVal === 'all' || filterVal === '') {
        return data;
    }
    if (filterVal === 'schedule') {
        return data.filter((item) => item.schedule_modifier.active === false);
    }
    if (filterVal === 'source') {
        return data.filter((item) => item.source.active === false);
    }
    if (filterVal === 'filter') {

        data.filter((item) => {
            return item.filters.some((filter) => {
                return filter.qualified === false;

            })
        });

    }
};

export const getCompareToObj = (row, extraInfo, possibleGroupByKeys) => {
    const currentStat = _.cloneDeep(row);
    const grp_by_val_time_frame_keys = _.pick(currentStat, ANALYTICS_TIMEFRAME_GROUP_BY_KEYS)
    if (!_.isEmpty(grp_by_val_time_frame_keys)) {
        if (!Date.parse(extraInfo?.selectedDateRange?.startDate) || !Date.parse(extraInfo?.prevDateRange?.startDate)) return null;
        Object.keys(grp_by_val_time_frame_keys).forEach(key => {
            currentStat[key] = getPrevValueToCompareForTimeFrame(key, currentStat, extraInfo)
        })
    }
    const grp_by_val_keys = _.pick(currentStat, possibleGroupByKeys)
    return findbyGroupByKeysAdminAnalytics(extraInfo?.compare_to_stats, grp_by_val_keys, possibleGroupByKeys) || null
}

const getDateForCompareAnalytics = (currentDate, startDate, prevStartDate, zonedStartFn, differenceFn, addFn) => {
    const zonedStartVal = zonedStartFn(startDate, UTC_TIMEZONE);
    const difference = differenceFn(currentDate, zonedStartVal);
    const prevZonedStartVal = zonedStartFn(prevStartDate, UTC_TIMEZONE)
    const prevComparedValue = addFn(prevZonedStartVal, difference);
    // Format to ISO string
    const resultDate = prevComparedValue.toISOString();
    return resultDate;
}

export const getPrevValueToCompareForTimeFrame = (key, row, extraInfo) => {
    const { selectedDateRange, prevDateRange } = extraInfo;
    const currentDate = new Date(row[key]);
    const prevStartDate = prevDateRange?.startDate;
    const startDate = selectedDateRange?.startDate;
    switch (key) {
        case ADMIN_ANALYTICS_TIMEFRAME_GROUP_BY_KEYS.HOUR:
            return row[key];
        case ADMIN_ANALYTICS_TIMEFRAME_GROUP_BY_KEYS.DATE:
            return getDateForCompareAnalytics(currentDate, startDate, prevStartDate, getZonedStartOfDay, differenceInDays, addDays);
        case ADMIN_ANALYTICS_TIMEFRAME_GROUP_BY_KEYS.WEEK:
            return getDateForCompareAnalytics(currentDate, startDate, prevStartDate, getZonedStartOfWeek, differenceInWeeks, addWeeks);
        case ADMIN_ANALYTICS_TIMEFRAME_GROUP_BY_KEYS.MONTH:
            return getDateForCompareAnalytics(currentDate, startDate, prevStartDate, getZonedStartOfMonth, differenceInMonths, addMonths);
        case ADMIN_ANALYTICS_TIMEFRAME_GROUP_BY_KEYS.QUARTER:
            return getDateForCompareAnalytics(currentDate, startDate, prevStartDate, getZonedStartOfQuarter, differenceInQuarters, addQuarters);
        case ADMIN_ANALYTICS_TIMEFRAME_GROUP_BY_KEYS.YEAR:
            return getDateForCompareAnalytics(currentDate, startDate, prevStartDate, getZonedStartOfYear, differenceInYears, addYears);
    }
}
